import { render, staticRenderFns } from "./AppSocialSubstack.vue?vue&type=template&id=7c38f245&scoped=true&"
import script from "./AppSocialSubstack.vue?vue&type=script&lang=js&"
export * from "./AppSocialSubstack.vue?vue&type=script&lang=js&"
import style0 from "./AppSocialSubstack.vue?vue&type=style&index=0&id=7c38f245&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7c38f245",
  null
  
)

export default component.exports